<template>
    <html>
        <body class="ovrflow desk_bckgnd_img_login">
            <header class="desk_display common--header header--overide">
                <b-row class="row_lr_margin">
                    <b-col cols="10" v-if="store.isLogoAvailable">
                        <img :src="store.groupDetail.cssp" alt="" class="img-responsive-class" style="max-height: 70px" />
                    </b-col>
                    <b-col cols="10" v-if="!store.isLogoAvailable">
                        <p class="app-header-title">{{ store.groupDetail.gnm }}</p>
                    </b-col>
                </b-row>
            </header>

            <div class="college_main_div">
                <b-container class="bv-example-row login_cont_height mob_col_padding">
                    <b-row align-h="center" class="dev_lr_margin row_height">
                        <b-col class="xs_col col-sm-10 col-md-7 col-lg-5 col_padding dev_position">
                            <b-container class="brand--logo">
                                <b-row>
                                    <b-col cols="2" class="text-left">
                                        <div class="bck-btn">
                                            <b-button type="Back" variant="outline-light" v-on:click="backAction"
                                                ><img src="images/back_blue.png"
                                            /></b-button>
                                        </div>
                                    </b-col>
                                    <b-col class="mob-display" cols="8" v-if="store.isLogoAvailable">
                                        <div class="text-center">
                                            <img :src="store.groupDetail.cssp" alt="" class="img-responsive-class" />
                                        </div>
                                    </b-col>
                                    <b-col class="mob-display" cols="8" v-if="!store.isLogoAvailable">
                                        <div class="text-center">
                                            <p class="init-header-title">{{ store.groupDetail.gnm }}</p>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                            <b-container class="app setpassword_contentDiv">
                                <b-row>
                                    <b-col><p class="title_text_otp">SET PASSWORD</p></b-col>
                                </b-row>
                                <b-row>
                                    <b-col
                                        ><p class="text-center-txt textWhiteColor">
                                            {{ this.passwordFormat }}
                                        </p></b-col
                                    >
                                </b-row>
                                <b-row class="justify-content-md-center">
                                    <b-col class="col-lg-10">
                                        <!-- Login Form -->
                                        <div class="">
                                            <b-form @submit="onSubmit">
                                                <b-container>
                                                    <div class="">
                                                        <input
                                                            class="inputstyle"
                                                            id="input-1"
                                                            placeholder="New Password"
                                                            type="password"
                                                            v-model="form.pwd"
                                                            autocomplete="off"
                                                            required
                                                        />
                                                        <span style="margin-left: -20px">
                                                            <img :src="hidePasswordSrc" alt="" @click="hideAndShowPassword" />
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <input
                                                            class="inputstyle"
                                                            id="input-2"
                                                            placeholder="Confirm Password"
                                                            type="password"
                                                            v-model="form.confirmpassword"
                                                            autocomplete="off"
                                                            required
                                                        />
                                                        <span style="margin-left: -20px">
                                                            <img :src="hideConfirmPasswordSrc" @click="hideAndShowConfirmPassword" />
                                                        </span>

                                                        <div class="setpassword__controls">
                                                            <!-- TODO: InspireDiagnosticsHealth -->
                                                            <!-- <b-button type="login" variant="" v-on:click="onSubmit">CONTINUE</b-button> -->
                                                            <b-row align-h="center">
                                                                <b-col class="col-sm-10 col-md-10 col-lg-10 col_padding dev_position">
                                                                    <b-button type="login" variant="" v-on:click="onSubmit"
                                                                        >COMPLETE REGISTRATION</b-button
                                                                    >
                                                                </b-col>
                                                            </b-row>
                                                            <br /><br />
                                                            <label v-if="errorStatus" class="setpassword_errorMessageLabel" id="errorLabel">
                                                                {{ errorMessage }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </b-container>
                                            </b-form>
                                        </div>
                                        <!--  Form End -->
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <Footer></Footer>
        </body>
    </html>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Footer,
    },
    data() {
        return {
            form: {
                eml: store.registration.eml,
                pwd: "",
                confirmpassword: "",
            },
            store: store,
            errorStatus: false,
            errorMessage: "",
            hidePasswordSrc: "images/hide password_active.png",
            showPasswordSrc: "images/show password.png",
            hideConfirmPasswordSrc: "images/hide password_active.png",
            showConfirmPasswordSrc: "images/show password.png",
            selectedItem: {
                did: "uudduuud23423432",
                hcids: [],
            },
        };
    },
    methods: {
        onSubmit(evt) {
            evt.target.reset;
            this.errorMessage = "";
            evt.preventDefault();

            if (navigator.onLine) {
                var decimal = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,100}$/;
                if (this.form.pwd.length == 0 && this.form.confirmpassword.length == 0) {
                    this.errorStatus = true;
                    this.errorMessage = "Both Passwords cannot be empty";
                } else if (decimal.test(this.form.pwd)) {
                    if (this.form.pwd == this.form.confirmpassword) {
                        var header = {};
                        //   headers: [
                        //     {
                        //       key: "Content-Type",
                        //       value: "application/json",
                        //       type: "text",
                        //     },
                        //   ],
                        // };

                        apiCall
                            .apiServiceCall("Update", "", "/user/setpassword", this.form, header)
                            .then((response) => {
                                if (response.data.status == 1) {
                                    var CryptoJS = require("crypto-js");
                                    var pwd = CryptoJS.AES.encrypt(this.form.pwd, "pwd").toString();
                                    window.localStorage.setItem("QW3F4OV6", pwd); //Password

                                    this.store.sessionID = response.data.data;
                                    //TODO: InspireDiagnosticsHealth
                                    // this.$router.push({ path: "/personal-details" });

                                    /* UNISYS Web browser SDK Integration - Starts */
                                    // TODO - The below random number generation code will be removed during production deployment.
                                    // let min = 0;
                                    // let max = 100;
                                    // let randomNum = Math.random() * (max - min) + min;
                                    // randomNum = Math.floor(randomNum);
                                    // let inspireId = store.registration.iid.concat(randomNum);
                                    let inspireId = store.registration.iid;
                                    console.log("inspireId :: ", inspireId);

                                    var urlString = "/user/register/".concat(store.registration.iid);
                                    var self = this;
                                    
                                    apiCall
                                        .apiServiceCall("Post", "", urlString, self.selectedItem, header)
                                        .then((response) => {
                                            if (response.data.status == 1) {
                                                store.registrationSuccessResponse = response.data.message;
                                                self.store.userDetails = response.data.data;
                                                // const data = JSON.stringify(response.data.data.iid);
                                                // window.localStorage.setItem("iid", data);

                                                var CryptoJS = require("crypto-js");
                                                var eml = CryptoJS.AES.encrypt(response.data.data.eml, "eml").toString();
                                                window.localStorage.setItem("LI3EIB", eml); //Email

                                                var pwd = CryptoJS.AES.encrypt(self.form.pwd, "pwd").toString();
                                                window.localStorage.setItem("QW3F4OV6", pwd); //Password

                                                self.$router.push({ path: "/registration_success" });
                                            } else {
                                                self.errorStatus = true;
                                                self.errorMessage = response.data.message;
                                            }
                                        })
                                        .catch((error) => {
                                            if (error.response.status == 500) {
                                                self.errorStatus = true;
                                                self.errorMessage = self.serverProblem;
                                            } else if (error.response.status == 401) {
                                                setTimeout(() => self.$router.push({ path: "/home" }), 2000);
                                            } else if (error.response.status == 504) {
                                                self.signout();
                                            } else {
                                                self.errorStatus = true;
                                                self.errorMessage = error.response.data.message;
                                            }
                                        });
                                    //   console.log('Success');

                                    //   this.$router.push({ path: "/registration_success" });

                                    //   let self = this;
                                    //   window.enrollCaptureUser(inspireId, function(response) {
                                    //     console.log("Data from enrolmentCallback", response);
                                    //     if (response.responseCode == 200) {
                                    //       self
                                    //         .$swal({
                                    //           icon: "success",
                                    //           title: '<strong style="color:black;font-size=22px">Enrollment Status</strong>',
                                    //           html: '<p Style="color:green; font-size:20px">' + "Enrollment Success.",
                                    //           showCloseButton: true,
                                    //         })
                                    //         .then(function() {
                                    //           var urlString = "/user/register/".concat(store.registration.iid);
                                    //           apiCall
                                    //             .apiServiceCall("Post", "", urlString, self.selectedItem, header)
                                    //             .then(response => {
                                    //               if (response.data.status == 1) {
                                    //                 store.registrationSuccessResponse = response.data.message;
                                    //                 self.store.userDetails = response.data.data;
                                    //                 // const data = JSON.stringify(response.data.data.iid);
                                    //                 // window.localStorage.setItem("iid", data);

                                    //                 var CryptoJS = require("crypto-js");
                                    //                 var eml = CryptoJS.AES.encrypt(response.data.data.eml, "eml").toString();
                                    //                 window.localStorage.setItem("LI3EIB", eml); //Email

                                    //                 var pwd = CryptoJS.AES.encrypt(self.form.pwd, "pwd").toString();
                                    //                 window.localStorage.setItem("QW3F4OV6", pwd); //Password

                                    //                 self.$router.push({ path: "/registration_success" });
                                    //               } else {
                                    //                 self.errorStatus = true;
                                    //                 self.errorMessage = response.data.message;
                                    //               }
                                    //             })
                                    //             .catch(error => {
                                    //               if (error.response.status == 500) {
                                    //                 self.errorStatus = true;
                                    //                 self.errorMessage = self.serverProblem;
                                    //               } else if (error.response.status == 401) {
                                    //                 setTimeout(() => self.$router.push({ path: "/home" }), 2000);
                                    //               } else if (error.response.status == 504) {
                                    //                 self.signout();
                                    //               } else {
                                    //                 self.errorStatus = true;
                                    //                 self.errorMessage = error.response.data.message;
                                    //               }
                                    //             });
                                    //         });
                                    //     } else {
                                    //       let errorMessage = "";
                                    //       if (response.responseCode === 400) {
                                    //         errorMessage = "Enrollment Failure";
                                    //       } else if (response.responseCode === 409) {
                                    //         errorMessage = "User Already Exists";
                                    //       } else if (response.responseCode === 500) {
                                    //         errorMessage = "Server Error";
                                    //       } else if (response.responseCode === 499 && response.userAction === "User Consent") {
                                    //         errorMessage = "User Cancels in User Consent Screen";
                                    //       } else if (response.responseCode === 499 && response.userAction === "Face Capture") {
                                    //         errorMessage = "User Cancels in Face Capture Screen";
                                    //       }
                                    //       self.$swal({
                                    //         icon: "error",
                                    //         title: '<strong style="color:black; font-size=22px">Enrollment Status</strong>',
                                    //         html: '<p Style="color:red; font-size:20px">' + errorMessage,
                                    //         showCloseButton: true,
                                    //       });
                                    //     }
                                    //   });
                                } else {
                                    this.errorStatus = true;
                                    this.errorMessage = response.data.message;
                                }
                            })
                            .catch((error) => {
                                if (error.response.status == 500) {
                                    this.errorStatus = true;
                                    this.errorMessage = this.serverProblem;
                                } else if (error.response.status == 401) {
                                    setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                } else if (error.response.status == 504) {
                                    this.signout();
                                } else {
                                    this.errorStatus = true;
                                    this.errorMessage = error.response.data.message;
                                }
                            });
                    } else {
                        this.errorStatus = true;
                        this.errorMessage = "Password and Confirm Password are not matching";
                    }
                } else {
                    this.errorStatus = true;
                    this.errorMessage = this.passwordFormat;
                }
            } else {
                this.errorStatus = true;
                this.errorMessage = this.checkInternetConnection;
            }
        },
        backAction() {
            this.$router.push({ path: "/otp" });
        },
        hideAndShowPassword() {
            if (document.getElementById("input-1").type === "password") {
                this.hidePasswordSrc = this.showPasswordSrc;
                document.getElementById("input-1").type = "text";
            } else {
                this.hidePasswordSrc = "images/hide password_active.png";
                document.getElementById("input-1").type = "password";
            }
        },
        hideAndShowConfirmPassword() {
            if (document.getElementById("input-2").type === "password") {
                this.hideConfirmPasswordSrc = this.showConfirmPasswordSrc;
                document.getElementById("input-2").type = "text";
            } else {
                this.hideConfirmPasswordSrc = "images/hide password_active.png";
                document.getElementById("input-2").type = "password";
            }
        },
    },
};
</script>
